
export const REORDER_CATEGORIES='REORDER_CATEGORIES'
export const REORDER_CATEGORIES_SUCCESS= 'REORDER_CATEGORIES_SUCCESS'
export const REORDER_CATEGORIES_ERROR= 'REORDER_CATEGORIES_ERROR'


export const ReorderCategories= (data) => ({
    type: REORDER_CATEGORIES,
    payload: data
})